import './styles/index.css'
import { createApp } from 'vue'
import App from './App.vue'
import { setupSentry } from './utils/sentry'

const app = createApp(App)

setupSentry(app)

app.mount('#app')
